/* Auto sign-out after inactivity: the browser's half (the server refuses an idle token on its own, see
   backend/services/session_idle.py). The last time the person did something is kept in localStorage so every open
   tab shares one clock: working in one tab keeps the others signed in, and all of them sign out together. */

export const LAST_ACTIVITY_KEY = 'fw_last_activity';
export const DEFAULT_TIMEOUT_HOURS = 8;
export const IDLE_REASON = 'idle';

export function timeoutMs(hours?: number | null): number {
  const h = Number(hours);
  return (Number.isFinite(h) && h > 0 ? h : DEFAULT_TIMEOUT_HOURS) * 3600 * 1000;
}

export function markActivity(at: number = Date.now()): void {
  try { localStorage.setItem(LAST_ACTIVITY_KEY, String(at)); } catch { /* storage blocked: the server check still applies */ }
}

export function lastActivity(): number | null {
  try {
    const v = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}

export function clearActivity(): void {
  try { localStorage.removeItem(LAST_ACTIVITY_KEY); } catch { /* ignore */ }
}

/** True when a saved session has been idle longer than the timeout (e.g. the browser was reopened next day). */
export function isIdleExpired(hours?: number | null): boolean {
  const last = lastActivity();
  return last !== null && Date.now() - last > timeoutMs(hours);
}
